import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    brokerContact: {
      inputType: 'text',
      title: 'Broker Contact & Agreement',
    },
    listingPrice: {
      inputType: 'text',
      title: 'Listing price & Adjustment',
    },
    listingStatus: {
      inputType: 'text',
      title: 'Listing Status',
    },
    marketStatus: {
      inputType: 'text',
      title: 'Market Status',
    },
    salesDate: {
      inputType: 'text',
      type: 'date',
      title: 'Expected Disposition Date',
    },
    expectedDispositionProceeds: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Expected Disposition Proceeds',
      prefix: '$',
    },
    realtorCommission: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Realtor Commission',
      prefix: '$',
    },
    offerSection: {
      inputType: 'section',
      title: 'Offers',
      span: 'full',
    },
  }
}

export const offerTypeOptions = ['Purchase', 'Lease', 'Lease to Purchase']

export const defaultOfferInputs = (): Record<string, InputType> => {
  return {
    date: {
      inputType: 'text',
      type: 'date',
      title: 'Offer Date',
      required: true,
    },
    type: {
      inputType: 'select',
      options: offerTypeOptions,
      title: 'Offer Type',
      hasDefaultOption: true,
      required: true,
    },
    buyerName: {
      inputType: 'text',
      title: 'Proposed Buyer Name',
      required: true,
    },
    amount: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Offer Amount',
      prefix: '$',
      required: true,
    },
    sellerConcession: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Seller Concession',
      prefix: '$',
      required: true,
    },
    closingDate: {
      inputType: 'text',
      type: 'date',
      title: 'Closing Date',
      required: true,
    },
  }
}

export const inputGroup: Record<string, Array<string>> = {
  Sale: [
    'brokerContact',
    'listingPrice',
    'listingStatus',
    'marketStatus',
    'salesDate',
    'expectedDispositionProceeds',
    'realtorCommission',
    'offerSection',
  ],
  Rental: [],
}
